import React from 'react'
import styled from 'styled-components'

import { CurrentJobs } from './CurrentJobs'
import { MyJobs } from './MyJobs'
import { isAdmin, isSupervisor, isSuperUser } from '../../../../common/functions'

const spaceBetweenCards = '32px'

const CardsContainer = styled.div`
  display: flex;
  flex-direction: row;
`

const CardXSpacer = styled.div`
  min-width: ${spaceBetweenCards};
`

export const Cards = () =>
  <CardsContainer>
    {
      (isSupervisor() || isAdmin() || isSuperUser()) && <><CurrentJobs/><CardXSpacer/></>
    }
    <MyJobs />
  </CardsContainer>
